import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";

import { startAccountFunding } from "../../account-funding";
import reloadFast from "../../../../assets/img/fast-funding.svg";
import { translate as t } from "../../../../infrastructure/translate/localization";

import "./balance-sections.scss";

class FastTransference extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: "",
    };
  }

  render() {
    const { amount } = this.state;
    return (
      <div className="balance-hidden-content balanceSection">
        <div className="cob-btn-group">
          <div className="thumbnail">
            <img src={reloadFast} alt="reload fast transference" />
            <span className="title-balance-section">
              {t("my-account-section.fast-charge")}
            </span>
          </div>

          <div>
            <div>
              <p>{t("my-account-section.fast-charge-confirm")}</p>
              <p className="fast-charge-requirements">
                {t("my-account-section.fast-charge-requirements.prefix")}{" "}
                <span
                  data-tip={t(
                    "my-account-section.fast-charge-requirements.sepa-area-tooltip"
                  )}
                >
                  {t("my-account-section.fast-charge-requirements.sepa-area")}{" "}
                </span>
                {t("my-account-section.fast-charge-requirements.suffix")}
              </p>
            </div>

            <div className="cob-btn-group">
              <div className="cob-input-group amount">
                <label className="input-label">
                  {t("my-account-section.amount-recharge")}
                </label>
                <div>
                  <input
                    className="with-icon"
                    placeholder={t("common-messages.amount")}
                    type="number"
                    value={amount}
                    onChange={(e) => this.setState({ amount: e.target.value })}
                  />
                  <FontAwesomeIcon icon="pen" alt="edit" />
                </div>
              </div>
              <button
                type="button"
                className="cob-btn btn-primary not-uppercase"
                disabled={amount.length === 0}
                onClick={() => startAccountFunding(amount)}
              >
                {t("actions.recharge")}
              </button>
            </div>
          </div>
        </div>
        <ReactTooltip
          className="tooltipMessage tooltipMessage_bottom"
          place="bottom"
          effect="solid"
          type="light"
        />
      </div>
    );
  }
}

export default FastTransference;
